import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { StorageHelper } from '../helpers/StorageHelper';

@Component({
  selector: 'app-cookie-settings',
  templateUrl: './cookie-settings.component.html',
  styleUrls: ['./cookie-settings.component.scss']
})
export class CookieSettingsComponent extends BaseComponent implements OnInit {

  @Input() showTitle: boolean = true;
  @Output() onClose: EventEmitter<string> = new EventEmitter<string>();

  googleServicesON: boolean;

  constructor() {
    super();
  }

  ngOnInit() {
    this.googleServicesON = StorageHelper.getInstance().get(StorageHelper.keys.cookiesAccepted) == "accepted";
  }

  save() {
    if(this.googleServicesON) {
      this.accept();
    }
    else {
      this.essentials();
    }
  }

  essentials() {
    this.onClose.emit("essentials");
  }

  accept() {
    this.onClose.emit("accepted");
  }

}
